import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { LegalMarkdown } from "@/components/LegalMarkdown";
import { legalDocuments, LEGAL_VERSION, LEGAL_EFFECTIVE_DATE, CONTACT_EMAIL } from "@/data/legal";
import { legalContent } from "@/data/legalContent";

export default function LegalDoc() {
  const { slug } = useParams();
  const doc = legalDocuments[slug];
  if (!doc) return <Navigate to="/legal" replace />;
  const content = legalContent[slug];

  return (
    <main className="min-h-screen" data-testid={`legal-doc-${doc.slug}`}>
      <Nav />
      <article className="mx-auto max-w-3xl px-6 pb-24 pt-36 sm:pt-44">
        <Reveal>
          <Link
            to="/legal"
            className="label-tech inline-flex items-center gap-2 text-neutral-400 transition-colors duration-300 hover:text-white"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" /> Legal Center
          </Link>
          <h1 className="mt-8 font-display text-4xl font-black tracking-tighter text-white sm:text-6xl" data-testid="legal-doc-title">
            {doc.title}
          </h1>
          <div className="mt-5 flex flex-wrap gap-3" data-testid="legal-doc-meta">
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 font-mono-plex text-xs text-neutral-300">
              Version {LEGAL_VERSION}
            </span>
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 font-mono-plex text-xs text-neutral-300">
              Effective {LEGAL_EFFECTIVE_DATE}
            </span>
          </div>
        </Reveal>

        <Reveal className="mt-4">
          <div data-testid="legal-doc-content">
            <LegalMarkdown content={content} />
          </div>
        </Reveal>

        <Reveal className="mt-16 rounded-2xl border border-white/10 bg-white/[0.03] p-6">
          <p className="text-sm leading-relaxed text-neutral-400">
            This page is published verbatim from the same source, version, and effective date as the
            JomKonvoi app's in-app Legal pages. Questions?{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#00F0FF] underline underline-offset-2" data-testid="legal-contact-link">
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </Reveal>
      </article>
      <Footer />
    </main>
  );
}
